<template>
	<section>
		<header-page
			actions
			name="companies"
			:title="title"
			:value-disabled="valueDisabled"
			@run-action="runAction"
		/>
		<app-actions
			:value-disabled="valueDisabled"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<backButtonRoute/>
		<company-list
			:columns="columns"
			:items-total-quantity="itemsTotalQuantity"
			:items-quantity="table.rows.length"
			:current-page="currentPage"
			:rows="table.rows"
			:last-page="table.lastPage"
			@delete-company="openConfirmation"
			@on-page="changePage"
			@on-search="onSearch($event, 'subsidiary')"
			@row-is-selected="rowIsSelected"
		/>
		<!--<action-bar
			class="action-mobile"
			:resource-uri="$route.name"
			:value-disabled="valueDisabled"
			@run-action="runAction"
		/> !-->
		<v-dialog
			content-class="confirmation-dialog"
			v-model="dialog"
			max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">{{ dialogMessage }}</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<v-btn
						type="button"
						@click="closeDialog"
						color="success"
						class="btn-action mr-1 white--text">
						Cancelar
					</v-btn>
					<v-btn
						type="button"
						color="error"
						@click="onDelete"
						class="btn-action ml-1 white--text">
						Eliminar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<router-view></router-view>
	</section>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import actionBar from '@/components/shared/action-bar/action-bar';
	import companyFilter from '@/components/companies/company-filter';
	import companyList from '@/components/companies/company-list';
	import l from '@/shared/lib';
	import appActions from '@/components/shared/app-actions/app-actions';
	import backButtonRoute from '@/components/shared/back-button-route';
	import { ACCOUNTING_DEFINITION, ACCOUNTING_RULE_LIST, ACCOUNTING_PARAMETRIZATION } from '../../shared/action-codes';

	async function created() {
		const dataUserInfo = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
		const newCustomerId = dataUserInfo.subsidiary.customerId;
		if (this.customerId) {
			this.params.customerId = Number(this.customerId) || newCustomerId;
		}
		this.$setCurrentSubsidiary({});
		this.$loadSubsidiaries({ context: this, params: this.params });
		const { headers } = await this.loadData('subsidiary');
		this.itemsTotalQuantity = Number(headers['x-quantity']);
	}

	async function changePage(page) {
		this.currentPage = page;
		this.params.page = page;
		await this.loadData('subsidiary');
	}

	function closeDialog() {
		this.dialog = false;
		this.dialogMessage = '';
		this.companyId = null;
	}

	async function loadCustomers(params) {
		this.isLoading = true;
		const uri = params.customerId ? `customer/${params.customerId}` : 'customer';
		const newParams = params.search ? { ...params } : null;
		const { data: customers } = await this.$http.get(uri, { params: newParams });
		this.isLoading = false;
		if (params.customerId) {
			this.customers = [{ ...customers }];
			this.customerSelected = customers.id;
			this.customerName = `${customers.name} ${customers.lastname}`;
			this.params.customerId = this.customerSelected;
			this.loadData('subsidiary');
		} else {
			this.customers = [...customers];
		}
	}

	async function onDelete() {
		try {
			await this.$http.patch(`subsidiary/${this.companyId}/disable`);
			this.showNotification('La empresa ha sido eliminada correctamente.');
			this.closeDialog();
			this.params.page = 1;
			this.currentPage = 1;
			this.loadData('subsidiary');
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	function openConfirmation({ id, name }) {
		this.companyId = id;
		this.dialogMessage = `¿Desea eliminar la empresa ${name} del listado?`;
		this.dialog = true;
	}

	function rowIsSelected(company) {
		this.dataSelected = [];
		const { id, name, customerId, isSelected } = company;
		this.$setCurrentSubsidiary(isSelected ? company : {});
		if (isSelected) {
			this.dataSelected.push({ id, customerId, name });
			this.onlyOneIsSelected(this.getSubsidiaries, id);
		}
	}

	function onlyOneIsSelected(subsidiaries, id) {
		const newSub = l.map(
			l.setNewProperty('isSelected', item => item.id === id),
			subsidiaries,
		);
		this.$updateSubsidiaries(newSub);
	}

	function runAction({ codeWeb }) {
		if (codeWeb !== 'company-new') {
			const { id, customerId, name } = this.dataSelected[0];
			if (codeWeb === ACCOUNTING_DEFINITION) {
				this.goTo('account-definitions', { query: { subsidiaryId: id, customerId, name } });
			} else {
				this.goTo(codeWeb, {
					params: { customerId, subsidiaryId: id }, query: { subsidiaryId: id, customerId, name },
				});
			}
		} else {
			const { customerId } = this.params;
			const { customerName } = this.$route.params;
			this.goTo(codeWeb, { params: { customerId, customerName } });
		}
	}

	function title() {
		const { customerName } = this.$route.params;
		const fullName = customerName ? customerName.split('-').join(' ').toLowerCase() : null;
		const pageTitle = this.$route.meta.title;
		return this.customerId ? `${fullName} > ${pageTitle}` : pageTitle;
	}

	function valueDisabled() {
		if (this.dataSelected.length !== 1) {
			return [
				{ code: ACCOUNTING_DEFINITION, disabled: true },
				{ code: ACCOUNTING_RULE_LIST, disabled: true },
				{ code: ACCOUNTING_PARAMETRIZATION, disabled: true },
			];
		}
		return [];
	}

	function data() {
		return {
			columns: [
				{ id: 1, name: 'Fecha de Inicio', value: 'createdAt', checked: true, visible: true, movil: true },
				{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true, movil: false },
				{ id: 3, name: 'Ruc', value: 'ruc', checked: true, visible: true, movil: true },
				{ id: 4, name: 'Acciones', checked: true, visible: true, flagVisible: true, movil: false },
			],
			companyId: null,
			currentPage: 1,
			customerName: '',
			itemsTotalQuantity: null,
			customers: [],
			customerSelected: 0,
			dataSelected: [],
			dialog: false,
			dialogMessage: '',
			isLoading: false,
		};
	}

	export default {
		name: 'page-company',
		components: {
			actionBar,
			companyFilter,
			companyList,
			appActions,
			backButtonRoute,
		},
		computed: {
			...mapGetters('subsidiary', [
				'getSubsidiaries',
			]),
			title,
			valueDisabled,
		},
		created,
		data,
		methods: {
			...mapActions('subsidiary', {
				$loadSubsidiaries: 'loadSubsidiaries',
				$setCurrentSubsidiary: 'setCurrentSubsidiary',
				$updateSubsidiaries: 'updateSubsidiaries',
			}),
			changePage,
			closeDialog,
			loadCustomers,
			onDelete,
			onlyOneIsSelected,
			openConfirmation,
			rowIsSelected,
			runAction,
		},
		props: {
			customerId: [Number, String],
		},
		watch: {
			$route(newVal) {
				if (newVal) {
					if (newVal.name === 'companies') {
						if (this.customerId) {
							this.params.customerId = Number(this.customerId);
						}
					}
				}
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/companies/page-company.vue